import { Trans } from "@lingui/react/macro";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

import { resetForm } from "@/api/form-reset";
import { Spinner } from "@/common/components/spinner/spinner";
import { Role } from "@/common/services/user";

import { useUserRoleMutation } from "./user-role-action.api";

type Fields = {
  role: Role;
};

const UserRoleAction = ({
  initialRole,
  userCompanyRelationId,
}: {
  initialRole: Role;
  userCompanyRelationId: number;
}) => {
  const form = useForm<Fields>({
    defaultValues: {
      role: initialRole,
    },
  });
  const queryClient = useQueryClient();
  const userRoleMutation = useUserRoleMutation();

  const handleSubmit = (data: Fields) => {
    userRoleMutation.mutate(
      { role: data.role, userCompanyRelationId },
      {
        onError: resetForm(form),
        onSuccess: () => {
          void queryClient.invalidateQueries();
        },
      },
    );
  };

  return (
    <form className="flex items-center gap-x-2">
      <select
        className="mt-2 w-[110px] rounded-lg border"
        disabled={userRoleMutation.status === "pending"}
        {...form.register("role", {
          onChange: async () => {
            await form.handleSubmit(handleSubmit)();
          },
        })}
      >
        <option value="USER">
          <Trans>Uživatel</Trans>
        </option>
        <option value="STATUTORY">
          <Trans>Statutár</Trans>
        </option>
      </select>
      {userRoleMutation.status === "pending" ? (
        <Spinner className="h-4! w-4!" withHint={false} />
      ) : null}
    </form>
  );
};

export { UserRoleAction };
